import {createFileRoute, redirect} from '@tanstack/react-router'

import simpleStorage from '@/utils/simpleStorage'

export const Route = createFileRoute('/clean-up')({
  component: () => null,
  beforeLoad: () => {
    simpleStorage.clear()
    throw redirect({
      to: '/',
      replace: true,
    })
  },
})
